import { DEFAULTS } from "./defaultSettings.js";
import { nodeViewDecorators } from "./nodeViewDecorators/index.js";
import { MENTION_TYPE } from "./types.js";
const pluginMentions = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: MENTION_TYPE,
    nodeViewDecorators
  };
};
export {
  pluginMentions
};
//# sourceMappingURL=viewer.js.map
